export default __webpack_public_path__ + "./images/gm.0c87cdc5.png";